import classNames from "classnames";
import Container from "components/grid/container";

import styles from "./styles.module.css";

const NotFound = ({ statusCode, similarDataCount }) => {
  const hasSimilar = statusCode === 410 && similarDataCount > 0;
  const is404 = statusCode === 404;
  const is410Empty = statusCode === 410 && similarDataCount === 0;

  const imageWrapperClasses = classNames({
    [styles.imageWrapperNotFound]: is404 || is410Empty,
    [styles.imageWrapper]: hasSimilar,
  });

  const getContent = () => {
    if (is404) {
      return {
        title: (
          <>
            404 - Aradığınız Sayfa
            <br />
            Bulunamadı
          </>
        ),
        imgSrc: "/assets/icons/404.svg",
        imgAlt: "Sayfa Bulunamadı",
      };
    }
    if (is410Empty) {
      return {
        title: (
          <>
            410 - Aradığınız Sayfa Artık
            <br />
            Mevcut Değil
          </>
        ),
        imgSrc: "/assets/icons/410.svg",
        imgAlt: "Sayfa Mevcut Değil",
      };
    }
    if (hasSimilar) {
      return {
        title: (
          <>
            410 - Aradığınız Sayfa Artık
            <br />
            Mevcut Değil
          </>
        ),
        subText: (
          <span className={styles.subText}>
            Aynı konumdaki diğer ilanları inceleyebilir
            <br />
            ya da yeniden arama yapabilirsiniz.
          </span>
        ),
        imgSrc: "/assets/icons/410.svg",
        imgAlt: "Sayfa Mevcut Değil",
      };
    }
    return null;
  };

  const content = getContent();
  if (!content) return null;

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={imageWrapperClasses}>
          <div className={styles.text}>
            <h1 className={styles.title}>{content.title}</h1>
            {content.subText}
          </div>
          <img className={styles.icon} src={content.imgSrc} alt={content.imgAlt} />
        </div>
      </Container>
    </div>
  );
};

export default NotFound;
